import { boolean, InferType, object, string } from 'yup';

// Fase 2 (2026-08-18): the four email-lifecycle-flow.md §6.1 categories replace the old
// accountNotification/qrNotification/marketingNotification booleans. ACCOUNT is deliberately
// absent from these schemas - it isn't opt-outable, so there's nothing for the preferences UI
// to send for it. These no longer correspond 1:1 to any User field, so there's no
// checkTypeCompliance against swagger-types here anymore - src/swagger-types.ts still has the
// pre-fase-2 EmailPreferenceInDto/EmailPreferenceInfoOutDto shape (three old booleans) until
// it's next regenerated from the backend; don't trust those two generated interfaces until then.
export const EmailPreferenceInfoOutSchema = object({
  email: string().required(),
  qrNotification: boolean().default(true),
  trialLifecycle: boolean().default(true),
  tips: boolean().default(true),
});
export type EmailPreferenceInfoOutSchema = InferType<typeof EmailPreferenceInfoOutSchema>;

export const EmailPreferenceInDtoSchema = object({
  token: string().required(),
  qrNotification: boolean().required(),
  trialLifecycle: boolean().required(),
  tips: boolean().required(),
});
export type EmailPreferenceInDtoSchema = InferType<typeof EmailPreferenceInDtoSchema>;

// Authenticated-session sibling (no token - the session already identifies the user).
export const EmailPreferenceUpdateInDtoSchema = object({
  qrNotification: boolean().required(),
  trialLifecycle: boolean().required(),
  tips: boolean().required(),
});
export type EmailPreferenceUpdateInDtoSchema = InferType<typeof EmailPreferenceUpdateInDtoSchema>;
